module.exports = __webpack_public_path__ + "img/367.1dc754a7.png";